<template>
  <div>
    <div id="main-wrapper">
      <StaticHeader v-if="staticHeaderList.includes($route.name)" />
      <Header v-else />
      <NoSideBarMain />
    </div>
  </div>
</template>

<script>
import Header from "@/components/fixedcomponents/header.vue";
import NoSideBarMain from "@/components/Layout/NoSideBarMain";
import StaticHeader from "@/components/fixedcomponents/staticHeader.vue";
export default {
  name: "LayoutNoSidebar",
  components: {
    Header,
    NoSideBarMain,
    StaticHeader,
  },

  data() {
    return {
      staticHeaderList: [
        "JobNotFound",
        "JobRegistration",
        "Registration",
        "ResumeChecker",
      ],
    };
  },
};
</script>
